import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';
import { type DeleteMemberParams } from '@app/client/resources/groups';

import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query useMutation to
 * delete a Member from a Pod.
 */
export function useDeleteMember() {
    const queryClient = useQueryClient();

    return useMutation(({ groupId, memberId }: DeleteMemberParams) => Groups.callDeleteMember({ groupId, memberId }), {
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries(groupsCacheKeys.members(variables.groupId));
            queryClient.invalidateQueries(groupsCacheKeys.group(variables.groupId));
        },
        onError: (_error: Error, variables) => {
            queryClient.invalidateQueries(groupsCacheKeys.members(variables.groupId));
        },
    });
}
